import { defineMessages } from 'react-intl'

const scope = `procurify.platform.legal-entities.features.reactivate-legal-entity.presenters.reactivate-legal-entity-presenter`

export default defineMessages({
  successToastTitle: {
    id: `${scope}.successToastTitle`,
    defaultMessage: '{name} is active again',
  },
  errorToastTitle: {
    id: `${scope}.errorToastTitle`,
    defaultMessage: 'We couldn’t reactivate this entity',
  },
  defaultErrorMessage: {
    id: `${scope}.defaultErrorMessage`,
    defaultMessage:
      'Something went wrong. Refresh the page and try again. If the problem continues, contact support.',
  },
})
